import type { SearchQueryParams } from 'afpnews-api'

export interface Column {
  readonly id: string
  type: 'topic' | 'search' | 'event'
  order: number
  lastUpdated: number
  documentsIds: string[]
  params: SearchQueryParams
  // Surlignage des termes : `undefined`/`true` => activé (défaut), `false` => désactivé.
  highlight?: boolean
}

export type Locale = 'fr' | 'en' | 'de' | 'es' | 'pt'

export interface Topic {
  label: string
  value: string
  icon: string
}

export type TopicLocale = Locale | 'ar'

export type Topics = Record<TopicLocale, Topic[]>

export const DOCUMENT_TYPES = [
  'text',
  'factcheck',
  'multimedia',
  'photo',
  'graphic',
  'video',
  'webstory'
] as const

export type DocumentType = (typeof DOCUMENT_TYPES)[number]

// Anciens noms `suggestion`/`quick` normalisés à la lecture (rétro-compat, cf. normalizeSkillType).
export type AiSkillType = 'general' | 'contextual'

export type AiSkillOrigin = 'system' | 'user' | 'dynamic'

export interface AiSkillDefinition {
  id: string
  label?: string
  labels?: Record<string, string>
  icon: string
  type: AiSkillType
  order?: number
  // Absent = applicable à tous les documents.
  documentTypes?: DocumentType[]
  // Plafond d'étapes de la boucle agent quand le message est ce skill (défaut MAX_TOOL_ITERATIONS).
  maxSteps?: number
  content: string
  // ISO, résolution last-write-wins à la synchro Supabase. Absent pour skills système/dynamiques.
  updatedAt?: string
}

export interface AiSkill {
  id: string
  label?: string
  labelKey?: string
  icon: string
  type: AiSkillType
  order?: number
  documentTypes?: DocumentType[]
  maxSteps?: number
  buildContent: (columnId?: string) => string
  origin: AiSkillOrigin
}

// Registre d'icônes dans la config IA pour ne pas importer Heroicons dans le module de types.
export type { PromptIcon } from '@/config/ai/skillIcons'
